import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  startNewEstimate() {
    this.newEstimate = true;
  }

  scrollToForm(event) {
    if (!this.newEstimate || event.target.id !== 'fee_estimator') return;

    this.newEstimate = false;
    event.target.scrollIntoView({ block: 'start' });
  }
}
